import React from "react";

import { Typography } from "@mui/material";

import Tooltip from "./Tooltip";

export const CloudFlowDescription: React.FC = () => (
  <Typography variant="body2">
    Build a&nbsp;
    <Tooltip
      title="CloudFlow"
      tooltipContentTitle="Put your FinOps processes on autopilot"
      tooltipContentLink={{
        title: "Learn more about DoiT CloudFlow",
        href: "https://help.doit.com/docs/cloudflow/intro",
      }}
      isEntitled
    >
      <Typography variant="body2">
        Automate process and workflows with CloudFlow. Build flows using actions from AWS, Google Cloud and DoiT APIs,
        putting your FinOps processes on autopilot.
      </Typography>
    </Tooltip>
    &nbsp;to create automated cloud processes that implement this recommendation.
  </Typography>
);
